// extracted by mini-css-extract-plugin
export var descriptionSection = "styles-module__descriptionSection___Mywc8";
export var tabContent = "styles-module__tabContent___feGhk";
export var textArea = "styles-module__textArea___MpM6b";
export var editButtons = "styles-module__editButtons___g1alI";
export var emptyTabContent = "styles-module__emptyTabContent___X0o1J";
export var emptyTabBtn = "styles-module__emptyTabBtn___Gizqu";
export var innerText = "styles-module__innerText___yp_bP";
export var lngBtn = "styles-module__lngBtn___X2JRA";